const theme = {
  colors: {
    text: '#93918f',
    brownishGrey: '#636363',
    link: '#0087ff',
    orange: '#fdb755',
  },
  font: {
    family: {
      default: '"Montserrat", sans-serif',
      headline: '"Bitter", serif',
    },
    size: {
      default: '16px',
    },
    lineHeight: {
      default: 1.69,
    },
  },
};

export default theme;
